import React, { useCallback, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import { Card, Col, Row } from "reactstrap";
import "../../assets/scss/style.css";
import Pagination, { bootstrap5PaginationPreset } from "react-responsive-pagination";
import { getEnquiriesByUser } from "services/userServices";

const UserEnquiries = () => {
  const { userId } = useParams();
  const [loading, setLoading] = useState(false);
  const [listingData, setListingData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const perPage = 10;

  const fetchData = useCallback(async (pageNumber, pageSize) => {
    try {
      setLoading(true);
      const res = await getEnquiriesByUser(userId, pageNumber, pageSize, "", "", "", "false");
      const items = res?.data?.items || [];
      setListingData(Array.isArray(items) ? items : []);

      const explicitPages = Number(
        res?.data?.totalPages ||
          res?.data?.pageCount ||
          res?.data?.pages ||
          res?.data?.pagination?.totalPages ||
          0
      ) || 0;
      if (explicitPages > 0) {
        setTotalPages(explicitPages);
      } else {
        const totalRecords = Number(
          res?.data?.total ||
            res?.data?.totalCount ||
            res?.data?.count ||
            res?.data?.totalRecords ||
            res?.data?.totalListings ||
            res?.data?.pagination?.total ||
            0
        ) || 0;
        let pages = Math.ceil(totalRecords / perPage);
        if (pages < 1 && items.length > 0) pages = 1;
        setTotalPages(pages);
      }
    } catch (err) {
      console.error(err);
      setListingData([]);
      setTotalPages(0);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    fetchData(currentPage, perPage);
  }, [fetchData]);

  const handlePageClick = (page) => {
    setCurrentPage(page);
    fetchData(page, perPage);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col lg="12">
            <Card className="card-transparent">
              <div className="mb-3">
                <Row className="d-flex align-items-center">
                  <Col lg="6">
                    <h5 className=" text-color-gredient">User Enquiries</h5>
                  </Col>
                  <Col lg="6" className="d-flex justify-content-end gap-2">
                    <Link to="/admin/users" className="btn all-common-btn">Back to Users</Link>
                   
                  </Col>
                </Row>
              </div>
              <div className="table-responsive">
                <Table id="user-enquiries-table" className="table common-table table-nowrap table-bordered">
                  <Thead>
                    <Tr>
                      <Th>Sr No</Th>
                      <Th>Name</Th>
                      <Th>Email</Th>
                      <Th>Phone</Th>
                     <Th>Property Addess</Th>
                      <Th>Message</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {loading ? (
                      <Tr>
                        <Td colSpan="5">Loading ...</Td>
                      </Tr>
                    ) : listingData.length > 0 ? (
                      listingData.map((element, index) => (
                        <tr key={index}>
                          <td>{(currentPage - 1) * perPage + (index + 1)}</td>
                          <td>{element?.name || "-"}</td>
                          <td>{element?.email || "-"}</td>
                          <td>{element?.phone||"-"}</td>
                          <td>{element?.property_id.address}</td>
                        
                          <td>{element?.message || "-"}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">No Enquiries Found</td>
                      </tr>
                    )}
                  </Tbody>
                </Table>
              </div>

              <Row className="mt-2">
                <Col md={9}></Col>
                <Col md={3}>
                  <Pagination
                    {...bootstrap5PaginationPreset}
                    current={currentPage}
                    total={Math.max(1, totalPages)}
                    onPageChange={handlePageClick}
                    className="pagination justify-content-end gap-1"
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default UserEnquiries;


